export class UrlConstants {
  public static readonly GameID: string = "gameID";
  public static readonly GameName: string = "gameName";
}
